import { ICreateRate, IEditRatePayload, IGetRateList, IRateDetails, IRateListSearch } from "../../../types/master/rateInterface";
import { RateActionTypes, RateActions } from "../../actionTypes/master/rateActionTypes";

export const createRate = (payload: ICreateRate): RateActionTypes => ({
  type: RateActions.CREATE_RATE,
  payload,
});

export const getRateList = (payload: IRateListSearch): RateActionTypes => ({
  type: RateActions.GET_RATE_LIST,
  payload,
});

export const setRateList = (rateList: Array<IGetRateList>): RateActionTypes => ({
  type: RateActions.SET_RATE_LIST,
  payload: rateList,
});

export const setRateListPageCount = (payload: number): RateActionTypes => ({
  type: RateActions.SET_RATE_LIST_PAGE_COUNT,
  payload,
});

export const getRateDataById = (id: number): RateActionTypes => ({
  type: RateActions.GET_RATE_DATA_BY_ID,
  payload: id,
});

export const setRateDataById = (payload: IRateDetails) => ({
  type: RateActions.SET_RATE_DATA_BY_ID,
  payload,
});

export const editRate = (payload: IEditRatePayload) => ({
  type: RateActions.EDIT_RATE_DATA_BY_ID,
  payload,
});
